<template>
<v-container fluid class="ma-0 pa-0">
	<v-parallax src="001.png" height="760">
		<div style="position: absolute; width: 100%; top: 0; left: 0;">
			<div style="width: 1020px; display:flex; justify-content:space-between; align-items: center; margin:0px auto;">
				<img style="background:rgba(255,255,255,0.6)" src="../img/LOGO1.png">
				<div style="letter-spacing: 2px; font-size: 15px;">
					<router-link to="/">首页</router-link>
					|
					<router-link active-class="active" to="/about">公司简介</router-link>
					|
					<router-link active-class="active" to="/shebei">设备工艺</router-link>
					|
					<router-link active-class="active" to="/pinpai">品牌案例</router-link>
					|
					<router-link active-class="active" to="/kehu">服务客户</router-link>
					|
					<router-link active-class="active" to="/lianxi">联系我们</router-link>
				</div>
			</div>
		</div>

		<v-row align="start" style="width: 1020px; margin: 300px auto;">
			<v-col cols="5">
				<div>
					<p style="font-size: 20px;letter-spacing:10px;color: white">WELCOME</p>
					<p style="color:white;font-size: 65px;font-weight: bold;line-height: 55px;text-shadow: rgba(0 0 0 0.5)">LOGIN<br>CREATIVE</p>
					<p class="ad_xiaozi">Export printing and packaging, far ahead in the same industry,<br>
						professional photography art album, oil painting, large photo output</p>
					<img src="@/img/ICON5.png">
				</div>
			</v-col>

			<v-col cols="7">
				<div style="width:480px; display:flex; justify-content:space-between;">
					<div style="margin:0 auto;">
						<p style="font-size: 20px;letter-spacing:10px;color:white">欢迎进入</p><br>
						<p style="font-size: 55px;letter-spacing:6px;font-weight:normal;color:white;">创意联合</p>
						<p style="font-size: 30px; font-weight:lighter; color: white; line-height:35px">设计·包装·印刷</p>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-parallax>

  <div>
    <div style="width: 1020px; height:100px; margin: 0 auto; border-left:2px solid yellow"></div>
    <div style="width: 1020px; margin: 60px auto;">
      <div style="background-image: url('ad01.png'); background-position:top right; height: 404px;">
        <div>
          <p style="font-size: 20px;letter-spacing:6px;color: gray">ABOUT US</p><br>
          <p class="enheader">CREATIVE<br>NUITED</p>
          <p class="biaoti">创意联合是谁</p>
          <p style="font-size: 30px; font-weight: lighter; color: gray; line-height: 45px;">专做出口印刷包装<br>质量行业领先</p>
          <img src="@/img/ICON.png" style="cursor: pointer;" @click="$router.push('/about')">
        </div>
      </div>
    </div>
    <div style="width: 1020px; height:100px; margin:0 auto; border-right:2px solid #ff00ff;"></div>
  </div>

	<v-parallax src="@/img/guangao01.jpg" height="450">
		<v-container>
			<v-row align="center" justify="center">
				<v-col class="text-center" cols="12">
					<p class="guanggao">HP Indigo x KBA x swissQprint Impala</p>
				</v-col>
				<v-col class="text-center" cols="12">
					<p class="fubiao">成功建立在产品和服务的质量及创新之上</p>
				</v-col>
			</v-row>
		</v-container>
	</v-parallax>

  <div>
    <div style="width: 1020px; height:100px; margin: 0 auto; border-right:2px solid dodgerblue"></div>
    <div style=" width: 1020px; margin: 60px auto;">
      <div style="background-image: url('ad02.jpg') ;background-position:top left; height: 404px;">
        <div style="text-align:right">
          <p style="font-size: 20px; letter-spacing:6px;color: gray">WHAT WE DO</p><br>
          <p class="enheader">PACKING<br>PRINTING</p>
          <p class="biaoti">创意联合能做什么</p>
          <p style="font-size: 30px; font-weight:lighter; color: gray; line-height:45px">设计·包装·印刷</p>
          <img src="@/img/ICON1.png" style="cursor: pointer;" @click="$router.push('/shebei')">
        </div>
      </div>
    </div>

    <div style="width: 1020px; height:100px; margin:0 auto; border-left: 2px solid yellow;"></div>
  </div>

	<v-parallax src="@/img/guangao02.jpg" height="450">
		<v-container>
			<v-row justify="center">
				<v-col align="center" cols="12">
					<p class="guanggao">Packing printing-each kind of paper printinga</p>
				</v-col>
				<v-col align="center" cols="12">
					<p class="fubiao">专业和口碑吸引众多客户</p>
				</v-col>
			</v-row>
		</v-container>
	</v-parallax>

  <div>
    <div style="width: 1020px; height:100px; margin: 0 auto; border-left: 2px solid dodgerblue"></div>
    <div style="width: 1020px; margin: 60px auto;">
      <div style="background-image: url('map.png') ;background-position:top right; height: 404px;">
        <div>
          <p style="font-size: 20px;letter-spacing:6px;color: gray">BUSINESS</p><br>
          <p class="enheader">ALL OVER<br>THE WORLD</p>
          <p style="font-size: 30px; font-weight:bold">客户遍及世界各地</p>
          <img src="@/img/ICON.png" style="cursor: pointer;" @click="$router.push('/kehu')">
        </div>
      </div>
    </div>
    <div style="width: 1020px; height:100px; margin:0 auto; border-right:2px solid yellow"></div>
  </div>

	<v-parallax src="002.jpg" height="860">
		<v-container>
			<v-row justify="center">
				<v-col align="center" cols="12">
					<p class="guanggao">Technlogies & Certification</p>
					<p class="fubiao">专业 · 实力 · 认证</p>
					<p class="xiwen">ISO9001质量管理体系，FSC/COC森林管理委员会/产销键关联体系认证，ICTI国际玩具协会认证。<br>从原料到印刷，我们均通过严格的环保认证，作为极具社会责任感的企业，为保护地球环境尽一份力，绿色地球理念践行者。</p>
				</v-col>
				<v-col align="center" cols="12">
					<v-img src="@/img/ICON2.png" contain max-width="860"></v-img>
				</v-col>
			</v-row>
		</v-container>
	</v-parallax>

	<LggDiwen></LggDiwen>
</v-container>
</template>


<script>
import LggDiwen from "@/components/lgg-diwen";

export default {
  name: 'Home',
  components: {LggDiwen}
}
</script>

<style scoped>
.enheader {
  mix-blend-mode: multiply;
  font-size: 65px;
  font-weight: bold;
  line-height: 55px;
  text-shadow: gainsboro 5px 5px 5px;
}

.biaoti {
  font-size: 33px;
  font-weight: bold;
}

.buttom_content > p {
  font-size: 13px;
  color: gray;
}

.guanggao {
  font-size: 50px;
  font-weight: bold;
  color: white;
}

.fubiao {
  font-size: 33px;
  font-weight: lighter;
  color: white;
  line-height: 50px
}

.xiwen {
  font-size: 16px;
  font-weight: lighter;
  color: white;
  line-height: 30px
}

.ad_xiaozi {
  color: white;
  font-size: 10px;
  font-weight: normal;
  line-height: 15px
}

a {
  color: white !important;
  font-style: normal;
  text-decoration: none;
}

.active {
  color: black;
}

.router-link-active {
  text-decoration: none;
}
</style>
